import { identifyUser } from "@soenergy/frontend-library/src/services/datadog"
import store from "@/store"

export default () => {
  const id = store.getters.accountNumber
  const email = store.getters.email
  const name = store.getters.fullName

  identifyUser({
    id,
    email,
    name,
  })
}
